import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { TrangThai } from './trang-thai';
@Injectable()
export class TrangThaiService {

    controller:string = 'DM_TrangThai';
    constructor(private http: Http) { }
    

    GetList(paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }
    GetListAll() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetAll", { headers: headers }).map(resp => resp.json());       
    }
    Save(item:TrangThai) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Delete(item:TrangThai) {
        item.TrangThai = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/Delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/danhmuc/dm-trang-thai/trang-thai.service.ts